
<template>
  <div class="wizard">
    <div
      class="step"
      v-bind:class="{ 'selected': (this.getIndex() == 1), 'passed': (this.getIndex() > 1), 'next': (this.getIndex() + 1 == 1) }"
    >
      <div class></div>
      <div class="step-body step-start">{{translation.title_step1.replace(':','')}}</div>
      <div class="step-triangle-end"></div>
      <span class="tooltiptext"></span>
    </div>
    <div
      class="step"
      v-bind:class="{ 'selected': (this.getIndex() == 2), 'passed': (this.getIndex() > 2), 'next': (this.getIndex() + 1 == 2) }"
    >
      <div class="step-triangle-start"></div>
      <div class="step-body">{{translation.title_step2.replace(':','')}}</div>
      <div class="step-triangle-end"></div>
      <span class="tooltiptext">{{translation.step1_message_pass_5_lead}}</span>
    </div>
    <div
      class="step"
      v-bind:class="{ 'selected': (this.getIndex() == 3), 'passed': (this.getIndex() > 3), 'next': (this.getIndex() + 1 == 3) }"
    >
      <div class="step-triangle-start"></div>
      <div class="step-body">{{translation.title_step3.replace(':','')}}</div>
      <div class="step-triangle-end"></div>
      <span class="tooltiptext">{{translation.step2_message_pass_25_lead}}</span>
    </div>
    <div
      class="step"
      v-bind:class="{ 'selected': (this.getIndex() == 4), 'passed': (this.getIndex() > 4), 'next': (this.getIndex() + 1 == 4)}"
    >
      <div class="step-triangle-start"></div>
      <div class="step-body">{{translation.title_step4.replace( ':','')}}</div>
      <div class="step-triangle-end"></div>
      <span class="tooltiptext">{{translation.step3_message_pass_payment}}</span>
    </div>
    <!-- <div
      class="step"
      v-bind:class="{ 'selected': (this.getIndex() == 5), 'passed': (this.getIndex() > 5), 'next': (this.getIndex() + 1 == 5)}"
    >
      <div class="step-triangle-start"></div>
      <div class="step-body">{{translation.title_step5.replace( ':','')}}</div>
      <div class="step-triangle-end"></div>
    </div> -->
    <!-- <div
      class="step"
      v-bind:class="{ 'selected': (this.getIndex() == 6), 'passed': (this.getIndex() > 6), 'next': (this.getIndex() + 1 == 6)}"
    >
      <div class="step-triangle-start"></div>
      <div class="step-body">{{translation.title_step6.replace( ':','')}}</div>
      <div class="step-triangle-end"></div>
      <span class="tooltiptext">{{translation.step4_message_pass_payment}}</span>
    </div> -->
    <!-- <div class="step" v-bind:class="{ 'selected': (this.getIndex() == 6)}"> -->
    <div class="step" v-bind:class="{ 'selected': (this.getIndex() > 4)}">
      <div class="step-triangle-start"></div>
      <div class="step-body step-end">{{translation.goal}}</div>
      <div class="step-triangle-end"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wizard-steps",
  props: ["translation"],
  components: {},
  data() {
    return { stepIndex: this.$parent.$parent.stepIndex };
  },
  mounted() {
    // console.log(this.props);
  },
  methods: {
    getIndex() {
      return parseInt(this.$parent.$parent.stepIndex);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wizard {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  width: 100%;
  height: 60px;
  margin-top: 25px;
  color: #838c93;
}

.step {
  // width: 180px;
  // height: 100%;
  text-align: center;
  background-color: #f8fafd;
  // margin-right: 15px;
}

.step-body {
  width: 150px; /* comprimento da cauda */
  height: 50px; /* largura da cauda     */
  background: #ffffff;
  position: absolute;
  font-weight: 700;
  font-size: 16px;
  padding-top: 5px;
  padding-top: 16px;
  padding-left: 16px;
  text-transform: uppercase;
}

.step-start {
  background-color: #ffffff;
  border-top-left-radius: 6px 6px;
  border-bottom-left-radius: 6px 6px;
}

.step-end {
  background-color: #ffffff;
  border-top-right-radius: 6px 6px;
  border-bottom-right-radius: 6px 6px;
  width: 170px;
}

.step-triangle-start {
  width: 0;
  height: 0;
  border-top: 25px solid transparent;
  border-left: 18px solid #f8fafd;
  border-bottom: 25px solid transparent;
  position: absolute;
  z-index: 999;
}

.step-triangle-end {
  width: 0;
  height: 0;
  border-top: 25px solid transparent; /* tamanho do topo ao meio */
  border-left: 18px solid #ffffff; /* comprimeto da seta      */
  border-bottom: 25px solid transparent; /* tamanho do meio a baixo */
  margin-left: 150px;
}

.tooltiptext {
  visibility: hidden;
  width: 360px;
  background-color: #fffae8;
  color: #858e94;
  text-align: center;
  border-radius: 6px;
  padding: 15px;
  position: absolute;
  z-index: 1;
  font-size: 20px;
  border: solid 2px #f3f3f3;
}

.next:hover {
  .tooltiptext {
    visibility: visible;
  }
}

.passed {
  color: #109aff;
}

.selected {
  color: #ffffff;

  .step-start {
    border-left: 18px solid #0295ff;
  }
  .step-triangle-end {
    border-left: 18px solid #0295ff;
  }
  .step-body {
    background-color: #0295ff;
  }
}
@media (max-width: 860px) {
  .wizard {
    flex-wrap: wrap;
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/wizardSteps.vue